import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  incrementTimer,
  startTimer,
  stopTimer,
} from "../../../../redux/features/gameSlice";

import "./Stopwatch.css";

const Stopwatch = () => {
  const dispatch = useDispatch();
  const selectedNewsie = useSelector(
    (state: any) => state.gameReducer.selectedNewsie
  );
  const activeModal = useSelector((state: any) => state.modalReducer.activeModal);

  const { time, timer_active } = useSelector((state: any) =>
    state.gameReducer.timer && state.gameReducer.timer[selectedNewsie]
      ? state.gameReducer.timer[selectedNewsie]
      : { time: -1, timer_active: false }
  );
  const winner = useSelector(
    (state: any) => state.gameReducer.winner[selectedNewsie]
  );
  useEffect(() => {
    
  }, [activeModal, winner]);

  useEffect(() => {
    let timer;
    if (!timer_active && !winner && !activeModal) dispatch(startTimer());
    if (activeModal) {
      dispatch(stopTimer());
    } else if (!winner) {
      dispatch(startTimer());
    }
    
    if (timer_active && !activeModal && !winner) {
      timer = setInterval(() => {
        dispatch(incrementTimer());
      }, 1000);
    }
    return () => {
      clearInterval(timer);
    };
  }, [timer_active, activeModal]);

  const minutes = Math.floor(time / 60);
  const seconds = time % 60 < 10 ? `0${time % 60}` : time % 60;

  return (
    <div className="stat-chip" aria-label="Time elapsed">
      <span className="stat-chip-icon">⏱</span>
      {minutes}:{seconds}
    </div>
  );
};

export default Stopwatch;
